import {ILoginService} from '../login.service';
export const unauthorizedInterceptorFactory =
    ($q:ng.IQService, $rootScope:ng.IRootScopeService) => {
      return {
        responseError: (rejection:any) => {
          if (rejection.status && rejection.status == 401) {
            $rootScope.$emit(ILoginService.UNAUTHORIZED_EVENT_NAME);
          }
          return $q.reject(rejection);
        }
      }
    };

unauthorizedInterceptorFactory.$inject = ['$q', '$rootScope'];



/** WEBPACK FOOTER **
 ** ./app/auth/interceptor/unauthorized-error.ts
 **/